module.exports = __webpack_public_path__ + "img/banner.779ce9c.jpg";